export default __webpack_public_path__ + "static/media/Groups.dde52f5a.svg";